// System App integration
// includes Bindable and Hotkeys; applies system stylesheet

{ Hotkeys } from @danielx/dui
{ Bindable, Undo } from @danielx/lib

export class Base with Undo, Bindable, Hotkeys {}

export default Base
